import axios from 'axios';

const baseUrl = window.wpApiSettings?.root || '/wp-json/dce/v1/';
const nonce = window.wpApiSettings?.nonce || '';

export async function getTreatments() {
  const { data } = await axios.get(baseUrl + 'treatments', { headers: { 'X-WP-Nonce': nonce } });
  return data;
}

export async function getLeads() {
  const { data } = await axios.get(baseUrl + 'leads', { headers: { 'X-WP-Nonce': nonce } });
  return data;
}
